import { Button, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { UploadImageButton } from '@hero/atoms';
import { UploadLogoModal } from '@hero/components/modals';
import { LOGO } from '@hero/constants';
import { ImagePreview } from '@hero/molecules';
import { useGetBranding, useUpdateBranding } from '@hero/services/organization-service/hooks';

import * as S from './style';

function Logo({ branding, onUpdateData }) {
  const { t } = useTranslation();
  const { data: { branding: { logoUrl: defaultLogoUrl } = {} } = {} } = useGetBranding();
  const { mutateAsync: updateBranding } = useUpdateBranding();

  const [isUploadModalOpen, setIsUploadModalOpen] = React.useState(false);
  const [uploadedLogo, setUploadedLogo] = React.useState();

  return (
    <S.LogoWrapper id={LOGO}>
      <Typography variant="body1Bold">{t('selectYourLogo')}</Typography>
      <Typography variant="body2" emphasis="weaker">
        {t('selectYourLogoDescription')}:
      </Typography>
      <S.ImagePreviewWrapper>
        <UploadImageButton onUpload={() => setIsUploadModalOpen(true)} />
        {uploadedLogo && uploadedLogo !== defaultLogoUrl && (
          <Button
            variant="link"
            onClick={() => {
              onUpdateData({ logoUrl: uploadedLogo });
            }}
          >
            <ImagePreview
              src={uploadedLogo}
              active={branding?.logoUrl === uploadedLogo}
              showActions={false}
            />
          </Button>
        )}
        {defaultLogoUrl && (
          <Button
            variant="link"
            onClick={() => {
              onUpdateData({ logoUrl: defaultLogoUrl });
            }}
          >
            <ImagePreview
              src={defaultLogoUrl}
              active={branding?.logoUrl === defaultLogoUrl}
              showActions={false}
            />
          </Button>
        )}
      </S.ImagePreviewWrapper>
      <UploadLogoModal
        isOpen={isUploadModalOpen}
        setIsOpen={setIsUploadModalOpen}
        uploadAction={({ cdnUrl }) => {
          if (!defaultLogoUrl) {
            updateBranding({
              branding: { logoUrl: cdnUrl }
            });
          }
          setUploadedLogo(cdnUrl);
          onUpdateData({
            logoUrl: cdnUrl
          });
        }}
      />
    </S.LogoWrapper>
  );
}

Logo.protoTypes = {
  branding: PropTypes.object,
  onUpdateData: PropTypes.func
};

export { Logo };
